import cn from 'classnames';
import { FormProvider } from 'react-hook-form';
import Modal from 'react-modal';
import { ItemInfo } from '@features/events/common/information';
import { Close } from '@shared/assets';
import { useAppDispatch } from '@shared/hooks';
import { IconButton } from '@shared/ui';
import { numberMask } from '@src/library/helpers/events/timePicker';
import { CustomEditorInputControlled } from '@src/modules/Authentication/InputsControlled';
import { closePaymentModal } from 'library/redux/modal';
import { usePaymentForm } from '../model';
import * as st from './styles.module.scss';

export const ModalPayment = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { submit, methods, payment, errors } = usePaymentForm();

  const handleConfirm = () => {
    submit();
    // Тут confirm действие
  };

  const handleReject = () => {
    dispatch(closePaymentModal());
    // Тут reject действие
  };

  const onRequestClose = () => {
    dispatch(closePaymentModal());
  };

  const { amount_to_pay: value } = methods.watch();
  const isDisabled = !!errors.amount_to_pay || !value;
  /**
   * TODO: Реализовать логику приёма платежа
   */

  return (
    <Modal
      isOpen
      overlayClassName={st.overlay}
      onRequestClose={onRequestClose}
      className={st.modal}
    >
      <FormProvider {...methods}>
        <div className={st.modal__head}>
          <IconButton variant="dark" onClick={handleReject}>
            <Close />
          </IconButton>
          <h3>Прием платежа</h3>
          <button
            type="button"
            onClick={handleConfirm}
            className={cn(st.submit, isDisabled && st.disabled)}
          >
            Готово
          </button>
        </div>
        <div className={st.modal__link}>
          <form className={st.form} onSubmit={submit}>
            <div className={st.form__item}>
              <ItemInfo
                title="Оплачено"
                value={payment.amount_paid}
                suffix="RUB"
                suffixClass={st.suffix}
              />
            </div>
            <div className={st.form__item}>
              <ItemInfo
                title="Задолженность"
                value={payment.balance_due}
                suffix="RUB"
                suffixClass={st.suffix}
                className={cn(st.due)}
              />
            </div>
            <div className={st.form__item}>
              <label>Внести</label>
              <div className={st.input}>
                <CustomEditorInputControlled
                  control={methods.control}
                  name="amount_to_pay"
                  label=""
                  sufix={'RUB'}
                  mask={numberMask}
                />
              </div>
            </div>
          </form>
        </div>
      </FormProvider>
    </Modal>
  );
};
